var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6608 1.35124C18.4039 1.09377 18.0551 0.949072 17.6914 0.949072C17.3277 0.949072 16.9789 1.09377 16.722 1.35124L9.99828 8.06124L3.27453 1.33749C3.01764 1.08002 2.66887 0.935322 2.30516 0.935322C1.94144 0.935322 1.59267 1.08002 1.33578 1.33749C0.799531 1.87374 0.799531 2.73999 1.33578 3.27624L8.05953 9.99999L1.33578 16.7237C0.799531 17.26 0.799531 18.1262 1.33578 18.6625C1.87203 19.1987 2.73828 19.1987 3.27453 18.6625L9.99828 11.9387L16.722 18.6625C17.2583 19.1987 18.1245 19.1987 18.6608 18.6625C19.197 18.1262 19.197 17.26 18.6608 16.7237L11.937 9.99999L18.6608 3.27624C19.1833 2.75374 19.1833 1.87374 18.6608 1.35124Z",
    fill: "#313C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.43acd1f0010c1634a70ce1abeb7ca9eb.svg";
export { ForwardRef as ReactComponent };